<template>
  <div class="ext-unit">
    <ins
      class="adsbygoogle"
      style="display: block"
      :data-ad-layout="type === 'leader-in-content' ? 'in-article' : false"
      :data-ad-client="pubId"
      :data-ad-slot="adId"
    />
  </div>
</template>

<script>
/**
 * Note: assumes that adsbygoogle.js is already loaded
 *
 *   LEADER-TOP
 *   large leaderboard (970x90)
 *   leaderboard (728x90)
 *   banner (468x60)
 *   mobile banner (320x50)
 *
 *   LEADER-LIST
 *   leaderboard (728x90)
 *   banner (468x60)
 *   mobile banner (320x50)
 *
 *   SIDEBAR
 *   medium rectangle (300x250)
 *
 *   LEADER-IN-CONTENT
 *   leaderboard (728x90)
 *   banner (468x60)
 *   mobile banner (320x50)
 *
 *   CARD-GRID / SIDEBAR
 *   large rectangle (336x280)
 *   medium rectangle (300x250)
 *
 *   DASHBOARD-PANEL
 *   large rectangle (336x280)
 *   medium rectangle (300x250)
 *
 *   NOT IN USE
 *   skyscraper (120x600)
 *   wide skyscraper (160x600)
 *   half banner (234x60)
 *   button (125x125)
 *   small rectangle (180x150)
 *   vertical banner (120 x 240)
 *   small square (200x200)
 *   square (250x250)
 *   half page (300x600)
 *   portrait (300x1050)
 *   billboard (970x250)
 */
export default {
  name: 'GoogleUnit',
  props: {
    adId: {
      type: String,
      required: true,
    },
    pubId: {
      type: String,
      default: 'ca-pub-2716376464462791',
    },
    type: {
      type: String,
      default: '',
    },
  },
  mounted() {
    // modify standard adsense code for js scoping: (adsbygoogle = window.adsbygoogle || []).push({})
    // break into 2 lines to get past prettier adding ; at beginning of line
    window.adsbygoogle = window.adsbygoogle || []
    window.adsbygoogle.push({})
  },
}
</script>
